if (!window.assignmentResourceBuilderRefreshMessageListenerAttached) {
    window.assignmentResourceBuilderRefreshMessageListenerAttached = true;

    const viewingMyAssignments = () => document.getElementById("is_vb")?.value === "false";

    window.addEventListener("message", function(event) {
        if (event.origin !== window.location.origin) { return; }
        if (event.data?.type !== "assignment-resource-builder:saved") { return; }

        window.assignmentResourceNotifications?.notifyAssignmentResourceSaved(
            event.data.assignmentResourceId,
            { clearTabCount: viewingMyAssignments() }
        );

        if (document.querySelector("#overview-spacer")) {
            if (window.Turbolinks) {
                window.Turbolinks.visit(window.location.toString());
            } else {
                window.location.reload();
            }
            return;
        }

        if (typeof window.refreshAssignmentResourceList === "function") {
            window.refreshAssignmentResourceList();
            return;
        }

        if (event.data.targetUrl) {
            window.location.assign(event.data.targetUrl);
        }
    });
}
